<nz-modal
  [nzWrapClassName]="'custom-consensus-nodata-modal'"
  [nzFooter]="null"
  [nzClosable]="false"
  [nzMaskClosable]="false"
  [nzVisible]="isCcNodataModalOpen$ | async"
>
  <ng-container *nzModalContent>
    <div class="header">
      <span class="title">Custom Consensus</span>
    </div>

    <div class="content">
      <div class="padded-x padded-y">
        Your custom consensus settings have been set to include brokers received
        in the last {{ relativeDays$ | async }} days in calculation, but there
        have been no revisions. Please adjust your custom consensus settings.
      </div>

      <div class="footer">
        <div class="action-btns">
          <button
            class="btn-primary"
            nz-button
            nzType="link"
            (click)="handleEditCC()"
          >
            Edit Custom Consensus
          </button>

          <button
            nz-button
            nzType="link"
            class="btn-primary"
            (click)="handleClearCC()"
          >
            Clear Custom Consensus
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</nz-modal>
